import React from 'react';
import styles from './RemoveConfirmation.module.scss';
import Button from '../Button/Button';
import { Theme } from '../../Enums/Theme.enum';
import Text from '../Base/Text/Text';

interface RemoveConfirmationProps {
	onConfirm?: () => void;
	onAbort?: () => void;
	confirmationText?: string;
	confirmationNote?: string;
	customButtons?: (
		handleAbortRemoval: () => void,
	) => React.ReactNode | React.ReactNode[];
	showAbort?: boolean;
}

export default function RemoveConfirmation(props: RemoveConfirmationProps) {
	const {
		onConfirm,
		onAbort,
		confirmationText = 'base.deleteConfirmationDefaultText',
		confirmationNote,
		customButtons,
		showAbort = true,
	} = props;

	const handleConfirmRemove = () => {
		onConfirm?.();
	};

	const handleAbortRemoval = () => {
		onAbort?.();
	};

	return (
		<div className={styles.wrapper}>
			<div className={styles.content}>
				<Text
					tx={confirmationText}
					className={styles.text}
					firstUpper
					noEscape
				/>
				{confirmationNote && (
					<Text
						tx={confirmationNote}
						className={styles.note}
						firstUpper
						noEscape
					/>
				)}
			</div>
			<div className={styles.controls}>
				{showAbort && (
					<Button
						onClick={handleAbortRemoval}
						title={'base.no'}
						theme={Theme.RED}
					/>
				)}
				{!customButtons ? (
					<Button
						onClick={handleConfirmRemove}
						title={'base.yes'}
						theme={Theme.GREEN}
					/>
				) : (
					customButtons(handleAbortRemoval)
				)}
			</div>
		</div>
	);
}
